import React from "react";
import PropTypes from "prop-types";
import styles from "./SyncErrorsModal.module.css";
import Button from "shared/Button";
import { Modal } from "shared/Modal";
import InfoItem from "DreamStream/Shared/InfoItem";
import ErrorList from "./ErrorList";
import formatDate from "shared/@utils/formatDate";

/**
 *
 * Interactive Modal with the list of different sync errors for the home and users pages.
 *
 */

export function SyncErrorsModal({ title, isOpen, onClose, errors, date }) {
  if (!isOpen) {
    return "";
  }
  return (
    <div className={styles.container}>
      <Modal
        isOpen={isOpen}
        title={title}
        closeBtn="none"
        className={styles.modal}
        onClose={onClose}
        children={
          <>
            <div className={styles.info}>
              <InfoItem
                label="Sync Date:"
                description={`${formatDate(date, "MM/DD/YYYY hh:mm A")}`}
              />
            </div>
            <div className={styles.errorsContainer}>
              <div className={styles.errors}>
                <ErrorList errors={errors} />
              </div>
            </div>

            <div className={styles.btnContainer}>
              <button className={styles.closeBtn} onClick={onClose}>
                CLOSE
              </button>
            </div>
          </>
        }
      />
    </div>
  );
}

SyncErrorsModal.propTypes = {
  /**
   * Title at the top of the modal .
   */
  Title: PropTypes.string,
  /**
   * Getter to determine if the the modal is displayed.
   */
  isOpen: PropTypes.bool,
  /**
   * Callback function for when the modal is closed.
   */
  onClose: PropTypes.func,
  /**
   * 	Array of error objects to be displayed
   */
  errors: PropTypes.array,
  /**
   * Sync Date
   */
  date: PropTypes.string,
  /**
   * Sync time
   */
  time: PropTypes.string,
};
